import { CreateButtonProps, CreateButton } from 'framework/ui/ui-builder';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { CREATE_OPPORTUNITY } from 'domain/sales/salesService';

const CreateOpportunityButton = (props: Omit<CreateButtonProps, 'url'>) => {
  const { getCreateUrl } = useOpportunityUrl();

  return (
    <CreateButton url={getCreateUrl()} permissionToCheck={CREATE_OPPORTUNITY} label="Create opportunity" {...props} />
  );
};

export default CreateOpportunityButton;
